// removed by extract-text-webpack-plugin
module.exports = {"type_block":"type_block","type_block_subtitle":"type_block_subtitle","type_block_row":"type_block_row","dark":"dark"};


//////////////////
// WEBPACK FOOTER
// ./src/view/screens/Project/components/TypeBlock/style.scss
// module id = 1369
// module chunks = 0